export const metaData = {
  text: {
    currentWeek: 'Текущая Неделя',
    currentMonth: 'Текущий Месяц',
    previousWeek: 'Прошлая Неделя',
    previousMonth: 'Прошлый Месяц',
    noPosts: 'Нету постов',
  },
};
